// App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Menu from './pages/Menu';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import About from './pages/About';
import OpeningHours from './pages/OpeningHours';

import Profile from './pages/Profile';
import Orders from './pages/Orders';
import Blog from './pages/Blog';

import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';

import AdminDashboard from './pages/AdminDashboard';
import AdminReservations from './pages/AdminReservations';
import AdminMenu from './pages/AdminMenu';
import AdminOrders from './pages/AdminOrders';
import AdminBlog from './pages/AdminBlog';
import Promotions from './pages/Promotions';
import DashboardHome from './pages/DashboardHome';

// ✅ Import the new Admin Table Management Page
import AdminTableManagement from './pages/AdminTableManagement';

import './styles/global.css';

const AppLayout = () => {
  const location = useLocation();
  const hideHeaderPaths = ['/opening-hours'];
  const shouldHideHeader = hideHeaderPaths.includes(location.pathname);

  return (
    <>
      {!shouldHideHeader && <Header />}

      <main style={{ minHeight: '80vh' }}>
        <Routes>
          {/* 🌐 Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/opening-hours" element={<OpeningHours />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />

          {/* 🔐 Auth Pages */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* 👤 User Pages */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/orders" element={<Orders />} />

          {/* 🧑‍💼 Admin Pages */}
          <Route path="/dashboard" element={<AdminDashboard />}>
            <Route index element={<DashboardHome />} />
            <Route path="reservations" element={<AdminReservations />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="promotions" element={<Promotions />} />
            <Route path="tables" element={<AdminTableManagement />} /> {/* ✅ NEW PAGE */}
          </Route>

          {/* 🔁 Redirect /admin → /dashboard */}
          <Route path="/admin" element={<Navigate to="/dashboard" replace />} />

          {/* 🧭 Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppLayout />
    </Router>
  );
}

export default App;
